import { Skeleton, Box } from "@mui/material";

const HelpDeskSkeleton = () => {
  return (
    <Box
      className="px-3 py-5"
      sx={{
        boxShadow: "4px 4px 25px rgba(0, 0, 0, 0.15)",
        borderRadius: "10px",
      }}
    >
      {/* Header */}
      <Box className="flex justify-between px-5 pb-4 mb-4 items-center border-b-2">
        <Skeleton variant="text" width={120} height={30} />
      </Box>

      {/* Section Title */}
      <Skeleton variant="text" width={150} height={20} />

      {/* Description Lines */}
      <Box className="py-4">
        <Skeleton variant="text" height={16} width="90%" sx={{ mb: 1 }} />
        <Skeleton variant="text" height={16} width="85%" />
      </Box>

      
    </Box>
  );
};

export default HelpDeskSkeleton;
